
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Tarifs d’un Community Manager : coûts et compétences clés",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez combien coûte un Community Manager, les compétences essentielles qu'il doit posséder et les tarifs pour une gestion efficace de vos réseaux sociaux.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Réseaux sociaux : Tarifs d’un Community Manager",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Combien coûte vraiment un community manager ? Quelles doivent être ses qualités ? Cet article vous explique tout !",
        },
      ],
    };
  },
};
